(() => {
    const $subMenuDropdownWraps = document.querySelectorAll('.site-menu-modal__menu .menu-item-has-children');

    const enableSubMenu = ($subMenuWrap, $subMenuToggle) => {
        if ($subMenuWrap.classList.contains('menu-item--active')) return;

        const $subMenuDropdown = $subMenuWrap.querySelector('.sub-menu-dropdown');
        const $backBtn = $subMenuWrap.querySelector('.sub-menu-dropdown__back');

        $subMenuDropdown.style.height = '0px';

        window.requestAnimationFrame(() => {
            $subMenuWrap.classList.add('menu-item--active');
    
            $subMenuToggle.setAttribute('aria-expanded', 'true');
            $backBtn?.setAttribute('aria-expanded', 'true');

            $subMenuDropdown.style.height = `${$subMenuDropdown.scrollHeight}px`;

            setTimeout(() => {
                $subMenuDropdown.style.height = '';
            }, 300);
        });
    };

    const disableSubMenu = ($subMenuWrap, $subMenuToggle) => {
        const $subMenuDropdown = $subMenuWrap.querySelector('.sub-menu-dropdown');
        const $backBtn = $subMenuWrap.querySelector('.sub-menu-dropdown__back');

        $subMenuDropdown.style.height = `${$subMenuDropdown.scrollHeight}px`;

        window.requestAnimationFrame(() => {
            $subMenuWrap.classList.remove('menu-item--active');
    
            $subMenuToggle.setAttribute('aria-expanded', 'false');
            $backBtn?.setAttribute('aria-expanded', 'false');

            $subMenuDropdown.style.height = '0px';

            setTimeout(() => {
                $subMenuDropdown.style.height = '';
            }, 300);
        });
    };

    const disableAllSubMenus = () => {
        $subMenuDropdownWraps.forEach($subMenuWrap => {
            const $subMenuToggle = $subMenuWrap.querySelector('a, button');

            if (!$subMenuToggle) return;

            disableSubMenu($subMenuWrap, $subMenuToggle);
        });
    }

    const initSubMenuDropdowns = () => {
        $subMenuDropdownWraps.forEach($subMenuWrap => {
            const $subMenuToggle = $subMenuWrap.querySelector('a, button');
            const $backBtn = $subMenuWrap.querySelector('.sub-menu-dropdown__back');

            if ($subMenuToggle) {
                $subMenuToggle.addEventListener('click', e => {
                    e.preventDefault();
                    
                    if ($subMenuWrap.classList.contains('menu-item--active')) {
                        disableSubMenu($subMenuWrap, $subMenuToggle);
                    } else {
                        enableSubMenu($subMenuWrap, $subMenuToggle);
                    }
                });
            }

            if ($backBtn) {
                $backBtn.addEventListener('click', e => {
                    e.preventDefault();
                    disableSubMenu($subMenuWrap, $subMenuToggle);
                });
            }
        });
    };

    initSubMenuDropdowns();
})();
